import { createRoot } from 'react-dom/client'

import { loadPolyfills } from '@dhl/barcode-scanner-input'

import { App } from './App'
import './i18n'

loadPolyfills().then(() => {
  const container = document.getElementById('root')
  if (container) {
    const root = createRoot(container)
    root.render(<App />)
  }
})
